/* 传入一个数组，id换name */
export function arrayByIdToNameStr({
    ArrayData,
    ID
}) {
    if ((!ID && ID !== 0) || !ArrayData) {
        return '-'
    }
    const item = ArrayData.find((item, index) => {
        return ArrayData[index].id == ID
    })
    return item?.name || '-'
}